export default __webpack_public_path__ + "static/media/tooltip-info.b4517eae.svg";